/* eslint-disable import/prefer-default-export */

// Accumulates all the different selectors

import * as backendSelectors from './selectors/backendStatus';
import * as cellSetsSelectors from './selectors/cellSets';
import * as genesSelectors from './selectors/genes';
import * as componentConfigSelectors from './selectors/componentConfig';
import * as secondaryAnalysesSelectors from './selectors/secondaryAnalyses';
import * as experimentSettingsSelectors from './selectors/experimentSettings';
import * as samplesSelectors from './selectors/samples';
import * as generalSelectors from './selectors/generalSelectors';
import * as genomeSelectors from './selectors/genomes';
import * as sltSelectors from './selectors/sampleLoadingTables';
import getAnalysisToolSelector from './selectors/getAnalysisTool';
import getIsScanpySelector from './selectors/getIsScanpy';
import getIsSeuratSelector from './selectors/getIsSeurat';
var getBackendStatus = function getBackendStatus() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return function (state) {
    return backendSelectors.getBackendStatus.apply(backendSelectors, params)(state.backendStatus);
  };
};
var getCellSets = function getCellSets() {
  for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    params[_key2] = arguments[_key2];
  }
  return function (state) {
    return cellSetsSelectors.getCellSets.apply(cellSetsSelectors, params)(state.cellSets);
  };
};
var getCellSetsHierarchy = function getCellSetsHierarchy() {
  for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    params[_key3] = arguments[_key3];
  }
  return function (state) {
    return cellSetsSelectors.getCellSetsHierarchy.apply(cellSetsSelectors, params)(state.cellSets);
  };
};
var getCellSetsHierarchyByType = function getCellSetsHierarchyByType() {
  for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    params[_key4] = arguments[_key4];
  }
  return function (state) {
    return cellSetsSelectors.getCellSetsHierarchyByType.apply(cellSetsSelectors, params)(state.cellSets);
  };
};
var getCellSetsHierarchyByKeys = function getCellSetsHierarchyByKeys() {
  for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    params[_key5] = arguments[_key5];
  }
  return function (state) {
    return cellSetsSelectors.getCellSetsHierarchyByKeys.apply(cellSetsSelectors, params)(state.cellSets);
  };
};
var getFilteredCellIds = function getFilteredCellIds() {
  for (var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    params[_key6] = arguments[_key6];
  }
  return function (state) {
    return cellSetsSelectors.getFilteredCellIds.apply(cellSetsSelectors, params)(state.cellSets);
  };
};
var getPlotConfigs = function getPlotConfigs() {
  for (var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    params[_key7] = arguments[_key7];
  }
  return function (state) {
    return componentConfigSelectors.getPlotConfigs.apply(componentConfigSelectors, params)(state.componentConfig);
  };
};
var getGeneList = function getGeneList() {
  for (var _len8 = arguments.length, params = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    params[_key8] = arguments[_key8];
  }
  return function (state) {
    return genesSelectors.getGeneList.apply(genesSelectors, params)(state.genes);
  };
};
var getFastqFiles = function getFastqFiles() {
  for (var _len9 = arguments.length, params = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    params[_key9] = arguments[_key9];
  }
  return function (state) {
    return secondaryAnalysesSelectors.getFastqFiles.apply(secondaryAnalysesSelectors, params)(state.secondaryAnalyses);
  };
};
var getSampleLTFile = function getSampleLTFile() {
  for (var _len0 = arguments.length, params = new Array(_len0), _key0 = 0; _key0 < _len0; _key0++) {
    params[_key0] = arguments[_key0];
  }
  return function (state) {
    return secondaryAnalysesSelectors.getSampleLTFile.apply(secondaryAnalysesSelectors, params)(state.secondaryAnalyses);
  };
};
var getPairs = function getPairs() {
  for (var _len1 = arguments.length, params = new Array(_len1), _key1 = 0; _key1 < _len1; _key1++) {
    params[_key1] = arguments[_key1];
  }
  return function (state) {
    return secondaryAnalysesSelectors.getPairs.apply(secondaryAnalysesSelectors, params)(state.secondaryAnalyses);
  };
};
var getFastqMatcherAreValid = function getFastqMatcherAreValid() {
  for (var _len10 = arguments.length, params = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    params[_key10] = arguments[_key10];
  }
  return function (state) {
    return secondaryAnalysesSelectors.getFastqMatcherAreValid.apply(secondaryAnalysesSelectors, params)(state.secondaryAnalyses);
  };
};
var getAutoDetectedSublibrarySelections = function getAutoDetectedSublibrarySelections() {
  for (var _len11 = arguments.length, params = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    params[_key11] = arguments[_key11];
  }
  return function (state) {
    return secondaryAnalysesSelectors.getAutoDetectedSublibrarySelections.apply(secondaryAnalysesSelectors, params)(state.secondaryAnalyses);
  };
};
var getMergedSublibrarySelections = function getMergedSublibrarySelections() {
  for (var _len12 = arguments.length, params = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    params[_key12] = arguments[_key12];
  }
  return function (state) {
    return secondaryAnalysesSelectors.getMergedSublibrarySelections.apply(secondaryAnalysesSelectors, params)(state.secondaryAnalyses);
  };
};
var getFastqMatcherInputs = function getFastqMatcherInputs() {
  for (var _len13 = arguments.length, params = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    params[_key13] = arguments[_key13];
  }
  return function (state) {
    return secondaryAnalysesSelectors.getFastqMatcherInputs.apply(secondaryAnalysesSelectors, params)(state.secondaryAnalyses);
  };
};
var getSelectedMetadataTracks = function getSelectedMetadataTracks() {
  for (var _len14 = arguments.length, params = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    params[_key14] = arguments[_key14];
  }
  return function (state) {
    return componentConfigSelectors.getSelectedMetadataTracks.apply(componentConfigSelectors, params)(state);
  };
};
var getFilterChanges = function getFilterChanges() {
  for (var _len15 = arguments.length, params = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    params[_key15] = arguments[_key15];
  }
  return function (state) {
    return experimentSettingsSelectors.getFilterChanges.apply(experimentSettingsSelectors, params)(state.experimentSettings);
  };
};
var getHasModality = function getHasModality() {
  for (var _len16 = arguments.length, params = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
    params[_key16] = arguments[_key16];
  }
  return function (state) {
    return experimentSettingsSelectors.getHasModality.apply(experimentSettingsSelectors, params)(state.experimentSettings);
  };
};
var getHasImmune = function getHasImmune() {
  for (var _len17 = arguments.length, params = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
    params[_key17] = arguments[_key17];
  }
  return function (state) {
    return experimentSettingsSelectors.getHasImmune.apply(experimentSettingsSelectors, params)(state.experimentSettings);
  };
};
var getIsImmuneOnly = function getIsImmuneOnly() {
  for (var _len18 = arguments.length, params = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
    params[_key18] = arguments[_key18];
  }
  return function (state) {
    return experimentSettingsSelectors.getIsImmuneOnly.apply(experimentSettingsSelectors, params)(state.experimentSettings);
  };
};
var getImmuneModality = function getImmuneModality() {
  for (var _len19 = arguments.length, params = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
    params[_key19] = arguments[_key19];
  }
  return function (state) {
    return experimentSettingsSelectors.getImmuneModality.apply(experimentSettingsSelectors, params)(state.experimentSettings);
  };
};
var getClusteringResolution = function getClusteringResolution() {
  for (var _len20 = arguments.length, params = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
    params[_key20] = arguments[_key20];
  }
  return function (state) {
    return experimentSettingsSelectors.getClusteringResolution.apply(experimentSettingsSelectors, params)(state.experimentSettings);
  };
};
var getIsScanpy = function getIsScanpy() {
  for (var _len21 = arguments.length, params = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
    params[_key21] = arguments[_key21];
  }
  return function (state) {
    return getIsScanpySelector.apply(void 0, params)(state);
  };
};
var getIsSeurat = function getIsSeurat() {
  for (var _len22 = arguments.length, params = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
    params[_key22] = arguments[_key22];
  }
  return function (state) {
    return getIsSeuratSelector.apply(void 0, params)(state);
  };
};
var getAnalysisTool = function getAnalysisTool() {
  for (var _len23 = arguments.length, params = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
    params[_key23] = arguments[_key23];
  }
  return function (state) {
    return getAnalysisToolSelector.apply(void 0, params)(state);
  };
};
var getMetadataToSampleIds = function getMetadataToSampleIds() {
  for (var _len24 = arguments.length, params = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
    params[_key24] = arguments[_key24];
  }
  return function (state) {
    return samplesSelectors.getMetadataToSampleIds.apply(samplesSelectors, params)(state.samples);
  };
};
var getSamples = function getSamples() {
  for (var _len25 = arguments.length, params = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
    params[_key25] = arguments[_key25];
  }
  return function (state) {
    return samplesSelectors.getSamples.apply(samplesSelectors, params)(state.samples);
  };
};
var getHasSampleTech = function getHasSampleTech() {
  for (var _len26 = arguments.length, params = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
    params[_key26] = arguments[_key26];
  }
  return function (state) {
    return generalSelectors.getHasSampleTech.apply(generalSelectors, params)(state);
  };
};
var getImmuneCellSet = function getImmuneCellSet() {
  for (var _len27 = arguments.length, params = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
    params[_key27] = arguments[_key27];
  }
  return function (state) {
    return generalSelectors.getImmuneCellSet.apply(generalSelectors, params)(state);
  };
};
var getHasPermissions = function getHasPermissions() {
  for (var _len28 = arguments.length, params = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
    params[_key28] = arguments[_key28];
  }
  return function (state) {
    return generalSelectors.getHasPermissions.apply(generalSelectors, params)(state);
  };
};
var getGenomeById = function getGenomeById() {
  for (var _len29 = arguments.length, params = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
    params[_key29] = arguments[_key29];
  }
  return function (state) {
    return genomeSelectors.getGenomeById.apply(genomeSelectors, params)(state);
  };
};
var getActiveSlt = function getActiveSlt() {
  for (var _len30 = arguments.length, params = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
    params[_key30] = arguments[_key30];
  }
  return function (state) {
    return sltSelectors.getActiveSlt.apply(sltSelectors, params)(state.sampleLoadingTables);
  };
};
var getPipelineReadySltList = function getPipelineReadySltList() {
  for (var _len31 = arguments.length, params = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
    params[_key31] = arguments[_key31];
  }
  return function (state) {
    return sltSelectors.getPipelineReadySltList.apply(sltSelectors, params)(state.sampleLoadingTables);
  };
};
export { getBackendStatus, getCellSets, getCellSetsHierarchy, getCellSetsHierarchyByType, getCellSetsHierarchyByKeys, getFilteredCellIds, getPlotConfigs, getGeneList, getFastqFiles, getSampleLTFile, getPairs, getFastqMatcherAreValid, getAutoDetectedSublibrarySelections, getMergedSublibrarySelections, getFastqMatcherInputs, getSelectedMetadataTracks, getFilterChanges, getAnalysisTool, getIsScanpy, getIsSeurat, getHasModality, getHasImmune, getIsImmuneOnly, getImmuneModality, getClusteringResolution, getMetadataToSampleIds, getSamples, getImmuneCellSet, getHasPermissions, getHasSampleTech, getGenomeById, getActiveSlt, getPipelineReadySltList };